import {
  Page,
  Text,
  View,
  Document,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

// Styles
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 11,
    fontFamily: "Helvetica",
    color: "#111",
  },

  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #ccc",
    paddingBottom: 10,
    marginBottom: 20,
  },

  logo: {
    width: 120,
    height: "auto",
  },

  sectionTitle: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 10,
    marginTop: 20,
    color: "#0A192F",
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
  },

  label: {
    fontWeight: 700,
    color: "#555",
  },

  value: {
    color: "#111",
  },

  eventImage: {
    width: "100%",
    height: 180,
    objectFit: "cover",
    borderRadius: 6,
    marginBottom: 20,
  },

  qrBox: {
    marginTop: 25,
    alignItems: "center",
    paddingTop: 20,
  },

  qr: {
    width: 120,
    height: 120,
  },

  footer: {
    marginTop: 30,
    borderTop: "1px solid #ccc",
    paddingTop: 10,
    textAlign: "center",
    color: "#666",
    fontSize: 10,
  },
});

const TicketPDF = ({ data, siteSettings }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* HEADER WITH LOGO */}
        <View style={styles.header}>
          <Image style={styles.logo} src={siteSettings?.logo?.url} />
          <Text>Ticket Receipt</Text>
        </View>

        {/* EVENT IMAGE */}
        <Image style={styles.eventImage} src={data.eventImageUrl} />

        {/* EVENT DETAILS */}
        <Text style={styles.sectionTitle}>Event Details</Text>

        <View style={styles.row}>
          <Text style={styles.label}>Event:</Text>
          <Text style={styles.value}>{data.eventName}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.label}>Venue:</Text>
          <Text style={styles.value}>{data.venue}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.label}>Date:</Text>
          <Text style={styles.value}>{data.date}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.label}>Start Time:</Text>
          <Text style={styles.value}>
            {new Date(data.startTime).toLocaleString()}
          </Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.label}>End Time:</Text>
          <Text style={styles.value}>
            {new Date(data.endTime).toLocaleString()}
          </Text>
        </View>

        {/* ORDER DETAILS */}
        <Text style={styles.sectionTitle}>Order Summary</Text>

        <View style={styles.row}>
          <Text style={styles.label}>Order ID:</Text>
          <Text style={styles.value}>{data.orderId}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.label}>Ticket:</Text>
          <Text style={styles.value}>{data.ticketName}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.label}>Ordered By:</Text>
          <Text style={styles.value}>{data.userName}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.label}>Ordered At:</Text>
          <Text style={styles.value}>{data.orderedAt}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.label}>Payment:</Text>
          <Text style={styles.value}>
            {data.paymentType === "paid" ? "Paid" : "Unpaid"}
          </Text>
        </View>

        {/* QR CODE */}
        {data.qrUrl && (
          <View style={styles.qrBox}>
            <Image src={data.qrUrl} style={styles.qr} />
            <Text style={{ marginTop: 8 }}>Scan to verify ticket</Text>
          </View>
        )}

        {/* FOOTER */}
        <Text style={styles.footer}>
          © {new Date().getFullYear()} {siteSettings?.title}. All rights
          reserved.
        </Text>
      </Page>
    </Document>
  );
};

export default TicketPDF;
